import React, { useState, useEffect } from 'react'
import { Calendar, User, Briefcase, Building2, X } from 'lucide-react'
import * as api from '../../../app/axios/api'
import { toast } from 'sonner'
import { getCookie } from '../../../app/axios/CookieConfig'
import { useNavigate } from 'react-router-dom'

const Employees = () => {
  const profileId = parseInt(getCookie('id'))
  const profileName = getCookie('name')
  const navigate = useNavigate()
  const [employees, setEmployees] = useState([])
  // const [showDeleteModal, setShowDeleteModal] = useState(false)
  const [showLeaveModal, setShowLeaveModal] = useState(false)
  const [leaveForm, setLeaveForm] = useState({
    leave_start_date: '',
    leave_end_date: '',
    total_number_of_leave_days_requested: '',
    reason_for_leave: '',
    leave_type: 'full_day',
    requested_by: profileId,
    employee_id: profileId,
  })

  const fetchEmployeeList = async () => {
    try {
      const res = await api.fetchEmployee()
      setEmployees(res.data)
    } catch (error) {
      toast.error('Failed to fetch records data')
      setEmployees([])
    }
  }

  useEffect(() => {
    fetchEmployeeList()
  }, [])

  // const handleDeleteClick = (employee) => {
  //   setSelectedEmployee(employee)
  //   setShowDeleteModal(true)
  // }

  // const confirmDelete = async () => {
  //   try {
  //     await api.deleteEmployee(selectedEmployee.id)
  //     setEmployees(
  //       employees.filter(
  //         (emp) => emp.employee_id !== selectedEmployee.employee_id,
  //       ),
  //     )
  //     toast.success('Employee deleted successfully')
  //   } catch (error) {
  //     toast.error('Failed to delete employee')
  //   } finally {
  //     setShowDeleteModal(false)
  //     setSelectedEmployee(null)
  //   }
  // }

  // const cancelDelete = () => {
  //   setShowDeleteModal(false)
  //   setSelectedEmployee(null)
  // }

  const handleLeaveClick = () => {
    setLeaveForm({
      leave_start_date: '',
      leave_end_date: '',
      total_number_of_leave_days_requested: '',
      reason_for_leave: '',
      leave_type: 'full_day',
      requested_by: profileId,
      employee_id: profileId,
    })
    setShowLeaveModal(true)
  }

  const calculateLeaveDays = (startDate, endDate) => {
    if (!startDate || !endDate) return 0
    const start = new Date(startDate)
    const end = new Date(endDate)
    const diffTime = Math.abs(end - start)
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1
    return diffDays
  }

  const handleLeaveFormChange = (e) => {
    const { name, value, type, checked } = e.target
    const newValue = type === 'checkbox' ? checked : value

    setLeaveForm((prev) => {
      const updated = { ...prev, [name]: newValue }

      if (name === 'leave_start_date' || name === 'leave_end_date') {
        const days = calculateLeaveDays(
          name === 'leave_start_date' ? value : prev.leave_start_date,
          name === 'leave_end_date' ? value : prev.leave_end_date,
        )
        updated.total_number_of_leave_days_requested = days
      }

      return updated
    })
  }

  const submitLeaveRequest = async () => {
    if (
      !leaveForm.leave_start_date ||
      !leaveForm.leave_end_date ||
      !leaveForm.reason_for_leave
    ) {
      toast.error('Please fill all required fields')
      return
    }

    try {
      await api.createEmployeeLeave(leaveForm)
      setShowLeaveModal(false)
      setLeaveForm({
        leave_start_date: '',
        leave_end_date: '',
        total_number_of_leave_days_requested: '',
        reason_for_leave: '',
        leave_type: 'full_day',
        requested_by: profileId,
        employee_id: profileId,
      })
      toast.success('Leave request submitted successfully')
    } catch (error) {
      toast.error('Failed to submit leave request')
    }
  }

  const cancelLeaveRequest = () => {
    setShowLeaveModal(false)
    setLeaveForm({
      leave_start_date: '',
      leave_end_date: '',
      total_number_of_leave_days_requested: '',
      reason_for_leave: '',
      leave_type: 'full_day',
      requested_by: profileId,
      employee_id: profileId,
    })
  }

  const handleClick = (id) => {
    navigate(`/employees/${id}`)
  }

  return (
    <div className='min-h-screen bg-gray-100 p-4 sm:p-6'>
      <div className='max-w-7xl mx-auto'>
        <div className='mb-6 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4'>
          <div>
            <h1 className='text-2xl sm:text-3xl font-bold text-gray-800'>
              Employee List
            </h1>
            <p className='text-gray-600 mt-1 text-sm sm:text-base'>
              Total Employees: {employees.length}
            </p>
          </div>
          <button
            onClick={handleLeaveClick}
            className='px-5 py-2.5 text-sm font-medium text-white bg-green-600 hover:bg-green-700 rounded-lg transition-colors duration-200 flex items-center space-x-2 shadow-sm'
          >
            <Calendar className='w-4 h-4' />
            <span>Create Leave Request</span>
          </button>
        </div>

        <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-5'>
          {employees.map((employee) => (
            <div
              key={employee.employee_id}
              onClick={() => handleClick(employee.id)}
              className='bg-white rounded-lg shadow hover:shadow-md hover:cursor-pointer transition-shadow duration-200 border border-gray-200'
            >
              <div className='p-4 sm:p-5 border-b border-gray-100'>
                <div className='flex items-start justify-between'>
                  <div className='flex items-center space-x-3'>
                    <div className='w-10 h-10 sm:w-12 sm:h-12 rounded-full bg-blue-100 flex items-center justify-center flex-shrink-0'>
                      <User className='w-5 h-5 sm:w-6 sm:h-6 text-blue-600' />
                    </div>
                    <div className='min-w-0'>
                      <h3 className='text-base sm:text-lg font-semibold text-gray-800 truncate'>
                        {employee.name}
                      </h3>
                      <p className='text-xs sm:text-sm text-gray-500'>
                        {employee.employee_id}
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className='p-4 sm:p-5 space-y-3'>
                <div className='flex items-center space-x-3'>
                  <Building2 className='w-4 h-4 text-gray-400 flex-shrink-0' />
                  <div className='min-w-0'>
                    <p className='text-xs text-gray-500'>Department</p>
                    <p className='text-sm font-medium text-gray-800 truncate'>
                      {employee.department || 'N/A'}
                    </p>
                  </div>
                </div>

                <div className='flex items-center space-x-3'>
                  <Briefcase className='w-4 h-4 text-gray-400 flex-shrink-0' />
                  <div className='min-w-0'>
                    <p className='text-xs text-gray-500'>Position</p>
                    <p className='text-sm font-medium text-gray-800 truncate'>
                      {employee.role}
                    </p>
                  </div>
                </div>
              </div>

              {/* <div className='p-3 sm:p-4 bg-gray-50 border-t border-gray-100 flex flex-col sm:flex-row items-stretch sm:items-center sm:justify-end gap-2'>
                <button
                  onClick={(e) => {
                    e.stopPropagation()
                    handleDeleteClick(employee)
                  }}
                  className='px-4 py-2 text-sm font-medium text-red-600 hover:bg-red-50 rounded-md transition-colors duration-200 flex items-center justify-center space-x-1'
                >
                  <Trash2 className='w-4 h-4' />
                  <span>Delete</span>
                </button>
              </div> */}
            </div>
          ))}
        </div>

        {employees.length === 0 && (
          <div className='text-center py-12 sm:py-16 bg-white rounded-lg'>
            <p className='text-gray-500 text-base sm:text-lg'>
              No employees found
            </p>
          </div>
        )}
      </div>

      {/* {showDeleteModal && (
        <div className='fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50'>
          <div className='bg-white rounded-xl shadow-2xl max-w-md w-full'>
            <div className='p-5 sm:p-6 border-b border-gray-200 flex items-center justify-between'>
              <h3 className='text-lg sm:text-xl font-bold text-gray-800 flex items-center space-x-2'>
                <Trash2 className='w-5 h-5 text-red-600' />
                <span>Confirm Delete</span>
              </h3>
              <button
                onClick={cancelDelete}
                className='text-gray-400 hover:text-gray-600'
              >
                <X className='w-5 h-5' />
              </button>
            </div>

            <div className='p-5 sm:p-6'>
              <p className='text-gray-700 mb-4 text-sm sm:text-base'>
                Are you sure you want to delete this employee?
              </p>
              {selectedEmployee && (
                <div className='bg-gray-50 rounded-lg p-4 space-y-2 border border-gray-200'>
                  <p className='text-sm'>
                    <span className='font-semibold text-gray-700'>Name:</span>{' '}
                    <span className='text-gray-600'>
                      {selectedEmployee.employee_name}
                    </span>
                  </p>
                  <p className='text-sm'>
                    <span className='font-semibold text-gray-700'>ID:</span>{' '}
                    <span className='text-gray-600'>
                      {selectedEmployee.employee_id}
                    </span>
                  </p>
                </div>
              )}
            </div>

            <div className='p-4 sm:p-6 bg-gray-50 border-t border-gray-200 flex flex-col sm:flex-row gap-3 sm:justify-end'>
              <button
                onClick={cancelDelete}
                className='w-full sm:w-auto px-5 py-2.5 text-sm font-medium text-gray-700 bg-white hover:bg-gray-100 rounded-lg border border-gray-300'
              >
                Cancel
              </button>
              <button
                onClick={confirmDelete}
                className='w-full sm:w-auto px-5 py-2.5 text-sm font-medium text-white bg-red-600 hover:bg-red-700 rounded-lg'
              >
                OK
              </button>
            </div>
          </div>
        </div>
      )} */}

      {showLeaveModal && (
        <div className='fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50 overflow-y-auto'>
          <div className='bg-white rounded-xl shadow-2xl max-w-2xl w-full my-8'>
            <div className='p-5 sm:p-6 border-b border-gray-200 flex items-center justify-between sticky top-0 bg-white rounded-t-xl'>
              <h3 className='text-lg sm:text-xl font-bold text-gray-800 flex items-center space-x-2'>
                <Calendar className='w-5 h-5 text-green-600' />
                <span>Create Leave Request</span>
              </h3>
              <button
                onClick={cancelLeaveRequest}
                className='text-gray-400 hover:text-gray-600'
              >
                <X className='w-5 h-5' />
              </button>
            </div>

            <div className='p-5 sm:p-6 space-y-4'>
              <div className='bg-blue-50 rounded-lg p-4 border border-blue-100'>
                <div className='grid grid-cols-1 sm:grid-cols-2 gap-3'>
                  <div>
                    <label className='text-xs font-semibold text-gray-600'>
                      Employee Name
                    </label>
                    <p className='text-sm font-medium text-gray-800 mt-1'>
                      {profileName}
                    </p>
                  </div>
                  <div>
                    <label className='text-xs font-semibold text-gray-600'>
                      Employee ID
                    </label>
                    <p className='text-sm font-medium text-gray-800 mt-1'>
                      {profileId}
                    </p>
                  </div>
                </div>
              </div>

              <div className='grid grid-cols-1 sm:grid-cols-2 gap-4'>
                <div>
                  <label className='block text-sm font-medium text-gray-700 mb-1'>
                    Start Date <span className='text-red-500'>*</span>
                  </label>
                  <input
                    type='date'
                    name='leave_start_date'
                    value={leaveForm.leave_start_date}
                    onChange={handleLeaveFormChange}
                    className='w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent text-sm'
                  />
                </div>
                <div>
                  <label className='block text-sm font-medium text-gray-700 mb-1'>
                    End Date <span className='text-red-500'>*</span>
                  </label>
                  <input
                    type='date'
                    name='leave_end_date'
                    value={leaveForm.leave_end_date}
                    onChange={handleLeaveFormChange}
                    min={leaveForm.leave_start_date}
                    className='w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent text-sm'
                  />
                </div>
              </div>

              <div>
                <label className='block text-sm font-medium text-gray-700 mb-1'>
                  Total Leave Days
                </label>
                <input
                  type='number'
                  name='total_number_of_leave_days_requested'
                  value={leaveForm.total_number_of_leave_days_requested}
                  readOnly
                  className='w-full px-3 py-2 border border-gray-300 rounded-lg bg-gray-50 text-sm'
                />
              </div>

              <div>
                <label className='block text-sm font-medium text-gray-700 mb-1'>
                  Leave Type <span className='text-red-500'>*</span>
                </label>
                <select
                  name='leave_type'
                  value={leaveForm.leave_type}
                  onChange={handleLeaveFormChange}
                  className='w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent text-sm'
                >
                  <option value='full_day'>Full Day</option>
                  <option value='morning'>Morning</option>
                  <option value='evening'>Evening</option>
                </select>
              </div>

              <div>
                <label className='block text-sm font-medium text-gray-700 mb-1'>
                  Reason for Leave <span className='text-red-500'>*</span>
                </label>
                <textarea
                  name='reason_for_leave'
                  value={leaveForm.reason_for_leave}
                  onChange={handleLeaveFormChange}
                  rows='4'
                  placeholder='Enter reason for leave...'
                  className='w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent text-sm resize-none'
                />
              </div>

              <div className='flex flex-col sm:flex-row gap-3 pt-4'>
                <button
                  onClick={cancelLeaveRequest}
                  className='w-full sm:w-auto px-6 py-2.5 text-sm font-medium text-gray-700 bg-white hover:bg-gray-100 rounded-lg border border-gray-300'
                >
                  Cancel
                </button>
                <button
                  onClick={submitLeaveRequest}
                  className='w-full sm:w-auto px-6 py-2.5 text-sm font-medium text-white bg-green-600 hover:bg-green-700 rounded-lg'
                >
                  Submit Leave Request
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default Employees
